import { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useUser from '../auth/useUser';

// Who sees the agent while it is piloted, inside an account that has it switched on. Named, so
// the next person adding one knows who the ids belong to and who to ask before removing them.
const SCHEDULING_AGENT_PILOT_ADMINS = [
  { id: 39336, name: 'Andre' },
  { id: 131, name: 'Netta' },
  { id: 36189, name: 'Jaime (Stockholm Live - Food & Beverage, account 61395)' }
];

// The one gate for the scheduling agent: nothing it adds to the UI appears without this.
const useCanAccessSchedulingAgent = () => {
  const { isSchedulingAgentEnabled } = useContext(ConfigContext);
  const { isUbeyaAdmin, data } = useUser();

  // The account setting is the floor: no admin sees the agent on an account that is not on it.
  if (!isSchedulingAgentEnabled) return false;

  return isUbeyaAdmin || SCHEDULING_AGENT_PILOT_ADMINS.some(({ id }) => id === data?.id);
};

export default useCanAccessSchedulingAgent;
